import { render, staticRenderFns } from "./mealType.vue?vue&type=template&id=5708cd04&scoped=true"
import script from "./mealType.vue?vue&type=script&lang=js"
export * from "./mealType.vue?vue&type=script&lang=js"
import style0 from "./mealType.vue?vue&type=style&index=0&id=5708cd04&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5708cd04",
  null
  
)

export default component.exports